export enum HomeAPIPath {
  Hohh = 'Home/Hohh',
  MyRumah = 'Home/MyRumah',
}
